/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'react',
	'../../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../ToolbarSectionDOMAPI',
	'../ToolbarSectionComponent',
	'../../ToolbarDockAPI'
], function(React, APIFactory, ToolbarSectionDOMAPI, ToolbarSectionComponent, ToolbarDockAPI){
	class OnDemandToolbarSectionDOM{
		static PROVIDER_ID = 'OnDemandToolbarSection';
		static PROVIDER_INDEX = 0;
		constructor({ features }){
			this._toolbarDockDOM = features['ToolbarDockDOM'];
			this._toolbarDock = features['ToolbarDock'];
			this._api = APIFactory.createAPI(this, [ToolbarSectionDOMAPI]);
			this._toolbarDockDOM.addProvider(OnDemandToolbarSectionDOM.PROVIDER_ID, this);
		}

		getAPI(){
			return this._api;
		}

		destroy(){
			delete this._api;
			delete this._node;
		}

		/** API implementations */

		setNode(node){
			this._node = node;
		}

		getNode(){
			return this._node;
		}

		getReactElement(){
			return <ToolbarSectionComponent
				className={OnDemandToolbarSectionDOM.PROVIDER_ID}
				stateProvider={this._toolbarDock}
				stateEvent={ToolbarDockAPI.UPDATE_DOCKED_TOOLBAR_STATE}
				focusEvent={ToolbarDockAPI.FOCUS_DOCKED_TOOLBAR}
				toolbarSectionDOM={this}
			/>;
		}

		getIndex(){
			return OnDemandToolbarSectionDOM.PROVIDER_INDEX;
		}
	}
	return OnDemandToolbarSectionDOM;
});
